import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { Box, ButtonBase, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { tokens } from "../../../theme";
import ButtonGroup from "../../theme/buttons/ButtonGroup";
import Shbutton from "../../theme/buttons/Shbutton";
import SHModal from "../../theme/Modal/SHModal";
import Subheading from "../../theme/text/Subheading";
import Text from '../../theme/text/Text';
import cx from 'classnames';
import { ShDropdownQuery } from '../../theme/dropdowns/Dropdown';
import { useGetRelationsQuery, useGetRelationsSelectQuery } from '../../../newapi/global/relation/relationSlice';
import { useAddTempRelationMutation } from '../../../newapi/user/userSlice';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateAuthData } from '../../../newapi/user/authentication/authSlice';

const CustomMyComponent = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    return (
        <ButtonBase
            key={props.key}
            onClick={props.onClick}
            className={cx('',{
                'active': props.isSelected
            })}
            sx={{
                flexShrink:0,
                height:32,
                minWidth:300,
                width:1,
                pl:1.5,
                pr:0.5,
                textAlign:"left",
                display:"flex",
                justifyContent:'space-between',
                alignItems:"center",
                borderRadius:2,
                '&.active' : {
                    background: theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                    color: theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400],
                    fontWeight:"900",
                }
            }}
        >
            {props.option.name}

            
        </ButtonBase>
    )
}

const MOpenRelation = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const {t} = useTranslation();
    const selectedCustomer = useSelector((state) => state.settings.environment.selectedId);
    // const defaultCustomer = useSelector((state) => state.auth.customers[0].id);

    const [relation, setRelation] = useState({
        id:-1,
        name: t("no_selection")
    })

    const [addTempRelationQuery, {data,isLoading}] = useAddTempRelationMutation();
    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }
    const handleClose = () => {
        // setReachTypeInfo({
        //     description: ""
        // });
        props.handleClose();
    }

    const refreshToken = useSelector((state) => state.auth.refreshToken);
    const dispatch = useDispatch();
    useEffect(() => {
        if(!isLoading  && data) {
            // console.log(data.data);
            dispatch(updateAuthData(data.data))
            props.handleClose();
        }
    }, [data,isLoading])
    return (
        <SHModal
            open={props.open}
            onClose={handleClose}
        >
            <Box
                sx={{
                    textAlign:"center",
                    paddingY:4,
                    paddingX:5,
                    display:"flex",
                    flexDirection:"column",
                    gap:1
                }}>
                <Subheading>{t("open_relation")}</Subheading>
                {/* <Text light>The data presented will automatically be filtered through the selected warehouses</Text> */}
            </Box>

            {/* BODY */}
            <Box
                sx={{
                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                    padding:3,
                    borderTopLeftRadius:16,
                    borderTopRightRadius:16,
                    display:"flex",
                    flexDirection:"column",
                    gap:2
                }}
            >
                
                <ShDropdownQuery
                    name="name"
                    onChange={(selected,object) => {
                        if(selected !== null) {
                            setRelation(object);
                        } else {
                            setRelation({
                                id:-1,
                                name: t("search_relation_placeholder")

                            })
                        }
                    }}
                    searchOptions={{
                        enabled:true,
                        placeholder:"none yet"
                    }}
                    displayName={"name"}
                    valueKey={"id"}
                    dataKey={null}
                    shComponent={<CustomMyComponent/>}
                    selected={relation.id }
                    content={useGetRelationsSelectQuery}
                    closeOnSelection
                >
                    {({anchorEl,onClick}) => (
                        <ButtonBase
                            onClick={onClick}
                            sx={{
                                height:40,
                                borderRadius:5,
                                background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                                display:"flex",
                                alignItems:'center',
                                px:0.5,
                                position:'relative',
                                "&:before" : {
                                    content:'""',
                                    position:'absolute',
                                    borderRadius:5,
                                    left:0,
                                    top:0,
                                    width:1,
                                    height:1,
                                    background: theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                                    // border:`1px solid ${colors.grey[100]}`,
                                    boxShadow:`0px 2px 4px ${colors.grey[200]}`,
                                }
                            }}
                        >

                            <Box
                                sx={{
                                    height:32,
                                    lineHeight:"32px",
                                    background:theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400],
                                    borderRadius:4,
                                    border: `1px solid ${ theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400]}`,
                                    width:110,
                                    textAlign:"center",
                                    fontSize:14,
                                    fontWeight:"bold",
                                    color:theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["light"],
                                }}
                            >
                                {t("relation")}

                            </Box>
                            <Box
                                sx={{
                                    flex:1,
                                    ml:1.5,
                                    textAlign:"left",
                                }}
                            >
                                <Text bold >
                                    {relation?.id === -1 ? t("no_selection") : relation?.name}
                                    {/* {relation?.name} */}
                                </Text>
                            </Box>
                            <Box
                                sx={{
                                    display:'flex',
                                    gap:1.5,
                                    alignItems:'center',
                                }}
                            >
                                <Box
                                    sx={{
                                        height:32,
                                        width:32,
                                        borderRadius:4,
                                        display:"flex",
                                        alignItems:'center',
                                        justifyContent:"center",
                                        background:theme.palette.mode === "dark" ? colors.blue[100] :  colors.primary[100],
                                        border: `1px solid ${ theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400]}`,
                                        color:  theme.palette.mode === "dark" ? colors.blue[400] :  colors.primary[400],
                                    }}
                                >
                                    <KeyboardArrowDownIcon/>

                                </Box>
                            </Box>

                        </ButtonBase>
                    )}
                </ShDropdownQuery>
            </Box>
            <Box
                component="footer"
                sx={{
                    
                    display:"block",
                    width:1,
                    paddingBottom: isStandAlone ? "32px" : "16px",
                    display:"flex",
                    alignItems:"center",
                    paddingRight:3,
                    zIndex:1058,
                    position:"relative",
                    paddingTop:2,
                    background:`${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    borderBottomLeftRadius:24,
                    borderBottomRightRadius:24,
                    justifyContent:"space-between",
                    "@media screen and (max-width: 47.9375em)" : {
                        paddingRight:0,
                    }
                }}
            >
                <Shbutton isCancel={true} className={"always-visible"} onClick={handleClose} color="primary" variant="text" startIcon={<ArrowRightAltIcon/>}>{t("cancel")}</Shbutton>
                <ButtonGroup version={2}>
                    <Shbutton 
                    isLoading={isLoading} 
                    className={"group-btn"} 
                    color={theme.palette.mode === "dark" ? "blue" : "primary"}
                    variant="contained" 
                    onClick={() => {
                        addTempRelationQuery({
                            customerId:selectedCustomer,
                            relationId:relation.id,
                            refresh_token:refreshToken,
                        })
                        setRelation({
                            id:-1,
                            name: t("no_selection")
                        })
                    }}
                    >{t("open")}</Shbutton>
                </ButtonGroup>
            </Box>
        </SHModal>
    )

}

export default MOpenRelation;